import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getPoWorkflowDashboard = async () => {
  try {
    const response = await apiClient.get('/adminInvoiceManagement/invoice/dashboard');
    return response.data?.response || response.data || {};
  } catch (error) {
    handleApiError(error);
    return { invoices: [] };
  }
};
